import { render, staticRenderFns } from "./MoleculeClearCache.vue?vue&type=template&id=381eb59b&"
import script from "./MoleculeClearCache.vue?vue&type=script&lang=js&"
export * from "./MoleculeClearCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports